var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 16.5C17.0625 16.8075 16.8075 17.0625 16.5 17.0625H1.5C1.1925 17.0625 0.9375 16.8075 0.9375 16.5C0.9375 16.185 1.1925 15.9375 1.5 15.9375H16.5C16.8075 15.9375 17.0625 16.185 17.0625 16.5Z",
    fill: "#161F28"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7504 7.48501V15.9375H2.21289L2.25039 7.4775C2.25039 7.02 2.46039 6.58504 2.82789 6.30004L8.07789 2.22004C8.61789 1.79254 9.3829 1.79254 9.9229 2.22004L15.1729 6.30004C15.5404 6.58504 15.7504 7.02001 15.7504 7.48501Z",
    fill: "#161F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6.1875H7.875C7.5675 6.1875 7.3125 5.9325 7.3125 5.625C7.3125 5.3175 7.5675 5.0625 7.875 5.0625H10.125C10.4325 5.0625 10.6875 5.3175 10.6875 5.625C10.6875 5.9325 10.4325 6.1875 10.125 6.1875Z",
    fill: "#161F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.25H6.375C5.7525 8.25 5.25 8.7525 5.25 9.375V16.5H12.75V9.375C12.75 8.7525 12.2475 8.25 11.625 8.25ZM8.0625 13.3125C8.0625 13.62 7.8075 13.875 7.5 13.875C7.1925 13.875 6.9375 13.62 6.9375 13.3125V12.1875C6.9375 11.88 7.1925 11.625 7.5 11.625C7.8075 11.625 8.0625 11.88 8.0625 12.1875V13.3125Z",
    fill: "#161F28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLives);
export default __webpack_public_path__ + "static/media/lives.2d540d23886de3797de619d9a0f62e4d.svg";
export { ForwardRef as ReactComponent };